import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { AppState } from "../../core";
import { BsModalService } from "ngx-bootstrap/modal";
import { ConfirmModalComponent } from "../../shared/components/confirm-modal/confirm-modal.component";
import { ImportFile } from "../../core/models/import-file";
import { PostProcessingService } from "../../core/services";
import { TableViewQueryCriteria } from "../../shared/components/table-view/table-view-component-base";
import { FilterFieldMode } from "../../shared/directives/filter-field.directive";

class DateDropdownOption {
  title: string;
  days: number;
  hours: number;
}

@Component({
  selector: "app-import-file-list",
  templateUrl: "./import-file-list.component.html",
  styleUrls: ["./import-file-list.component.css"],
})
export class ImportFileListComponent implements OnInit {
  isLoading = false;

  dateDropdownOptions: DateDropdownOption[] = [
    { title: "past hour", days: 0, hours: 1 },
    { title: "past 24 hours", days: 0, hours: 24 },
    { title: "past 7 days", days: 7, hours: 0 },
    { title: "past 2 weeks", days: 14, hours: 0 },
    { title: "past month", days: 30, hours: 0 },
    { title: "past 3 months", days: 90, hours: 0 },
    { title: "past year", days: 365, hours: 0 },
  ];

  selectedDateOption: DateDropdownOption = this.dateDropdownOptions[2];

  importFiles: ImportFile[] = [];

  filterObj: any = {};
  initialStageFilterMode: FilterFieldMode = "contains";

  constructor(
    public appState: AppState,
    public postProcessingService: PostProcessingService,
    private datePipe: DatePipe,
    private bsModalService: BsModalService
  ) {
    this.filterObj.stage = appState.activeStage;
    if (this.filterObj.stage) {
      this.initialStageFilterMode = "=";
    }
  }

  ngOnInit(): void {
    // post processing tab will tell this component when to load
    //this.load()
  }

 
  async load() {
    this.isLoading = true;
    try {
      let queryCriteria: TableViewQueryCriteria = {};
      if (this.selectedDateOption) {
        queryCriteria.filters = [
          {
            key: "pastHours",
            mode: "=",
            value:
              "" +
              (this.selectedDateOption.hours +
                this.selectedDateOption.days * 24),
          },
        ];
      }
      const resp = await this.postProcessingService.findImportFiles(
        queryCriteria
      );
      const promises = resp.rows.map(async (file: ImportFile) => {
          let params = {
            fileId: "" + file.id,
            fileName: file.filename,
            tableName: file.tablename,
          };
          const {min, max} = await this.postProcessingService.getImportFileTableEarliestAndLatestCallLocationTime(params).then(earliestLatestTime => {
            return earliestLatestTime[0]
          })
          file.earliesttime = min;
          file.latesttime = max;
          
          file.rowcount = await this.postProcessingService.getImportFileTableRowCount(params).then(rowcountArray => {
            return parseInt(rowcountArray[0].count)
          })
          return file
        })

      this.importFiles = await Promise.all(promises).then(resp => resp)
    } catch (error) {
      console.error(error);
      this.postProcessingService.publishError(error, this);
    }
    this.isLoading = false;
  }

  onDateChange = (selectedDateOption: DateDropdownOption) => {
    this.load();
  };

  formatImportTime = (strDate) => {
    return this.datePipe.transform(strDate, "yyyy-MM-dd HH-mm-ss");
  };

  async deleteFile(file: ImportFile) {
    let params = {
      fileId: "" + file.id,
      fileName: file.filename,
      tableName: file.tablename,
    };
    try {
      const rowCount =
        await this.postProcessingService.getImportFileTableRowCount(params);
      let initialState = {
        onYes: async () => {
          try {
            await this.postProcessingService.deleteImportFile(params);
          } catch (e: any){
            console.error(e);
            this.appState.notifyError('Delete import file error',this,5);
            this.postProcessingService.publishError(e,this);
          } finally {
            this.load();
          }
        },
        question: `Are you sure you want to delete file [${file.filename}]? <br />Deleting this file will delete [${rowCount[0].count}] row(s) in table [${file.tablename}]!`,
        focusOnNo: true,
        yesStyle: "btn btn-danger",
      };
      this.bsModalService.show(ConfirmModalComponent, { initialState });
    } catch ( e: any ) {
      console.error(e);
      this.postProcessingService.publishError(e,this);
    }
  }
}
